import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const installmentTotalValidator: ValidatorFn = (
  group: AbstractControl,
): ValidationErrors | null => {
  const installmentAmountCtrl = group.get('installmentAmount');
  const installmentCountCtrl = group.get('installmentCount');
  const downPaymentCtrl = group.get('downPayment');
  const fullPriceCtrl = group.get('fullPrice');

  if (!installmentAmountCtrl || !installmentCountCtrl || !fullPriceCtrl || !downPaymentCtrl) {
    return null;
  }

  const installmentAmount = Number(installmentAmountCtrl.value);
  const installmentCount = Number(installmentCountCtrl.value);
  const fullPrice = Number(fullPriceCtrl.value);
  const downPayment = Number(downPaymentCtrl.value);

  if (isNaN(installmentAmount) || isNaN(installmentCount) || isNaN(fullPrice)) {
    return null;
  }

  const total = installmentAmount * installmentCount + downPayment;
  if (Math.round(total * 100) !== Math.round(fullPrice * 100)) {
    installmentAmountCtrl.setErrors({
      ...installmentAmountCtrl.errors,
      installmentTotalMismatch: true,
    });
    return { installmentTotalMismatch: true };
  }

  // clean up error if it was previously set
  if (installmentAmountCtrl.hasError('installmentTotalMismatch')) {
    const errors = { ...installmentAmountCtrl.errors };
    delete errors['installmentTotalMismatch'];
    installmentAmountCtrl.setErrors(Object.keys(errors).length ? errors : null);
  }

  return null;
};
